import { useLayoutEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Typography } from "@mui/material";

import NotebookIcon from "@/fragments/NotebookIcon";

const ICON_GAP_PX = 12;

export default function ArtistLogo({ size = 24, fitWidth = false }) {
  const { artistKey } = useParams();
  const text = artistKey || "notebook";

  const wrapperRef = useRef(null);
  const [scale, setScale] = useState(1);

  useLayoutEffect(() => {
    if (!fitWidth) return;
    const wrapper = wrapperRef.current;
    if (!wrapper) return;

    const measureNaturalWidth = () => {
      const span = document.createElement("span");
      span.style.cssText =
        "position:absolute;left:-9999px;top:-9999px;visibility:hidden;white-space:nowrap;";
      span.style.fontFamily = "'Montserrat Alternates', sans-serif";
      span.style.fontWeight = "700";
      span.style.fontSize = `${size}px`;
      span.textContent = text;
      document.body.appendChild(span);
      const w = span.getBoundingClientRect().width;
      document.body.removeChild(span);
      return w + size + ICON_GAP_PX;
    };

    const update = () => {
      const avail = wrapper.offsetWidth;
      const natural = measureNaturalWidth();
      if (!avail || !natural) return;
      setScale(avail / natural);
    };

    update();

    const ro = new ResizeObserver(update);
    ro.observe(wrapper);

    let cancelled = false;
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => {
        if (!cancelled) update();
      });
    }

    return () => {
      cancelled = true;
      ro.disconnect();
    };
  }, [text, size, fitWidth]);

  const effectiveSize = fitWidth ? size * scale : size;

  return (
    <Box
      ref={wrapperRef}
      className="artist-logo"
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        width: fitWidth ? "100%" : undefined,
      }}
    >
      <NotebookIcon size={effectiveSize} />

      <Typography
        style={{
          fontFamily: "'Montserrat Alternates', sans-serif",
          fontWeight: 700,
          fontSize: `${effectiveSize}px`,
          marginBottom: "0px",
          marginLeft: `${ICON_GAP_PX}px`,
          whiteSpace: "nowrap",
        }}
      >
        {text}
      </Typography>
    </Box>
  );
}
